import { UIElement } from '../../ui-element';
import styles from './ui-bottom-navigation.css';
import { Component } from '../../../decorators/component.decorator';

/**
 * @class
 * @memberof SharedComponents
 * @augments {UIElement}
 * @alias UIBottomNavigation
 * @element ui-bottom-navigation
 * @classdesc Represents a class for <code>ui-bottom-navigation</code> element.
 * Can be used for mobile view navigation bar.
 * Meant to be used in conjunction with <code>ui-bottom-navigation-button</code>
 * @slot
 * @example
 * <ui-bottom-navigation>
 *   <ui-bottom-navigation-button glyph="home" label="Overview"></ui-bottom-navigation-button>
 *   <ui-bottom-navigation-button glyph="redesign-arrows-left-right-merged-on-top" label="Payments"></ui-bottom-navigation-button>
 *   <ui-bottom-navigation-button glyph="redesign-line-growth-arrow" label="Investments"></ui-bottom-navigation-button>
 *   <ui-bottom-navigation-button glyph="redesign-euro-sign-inside-circle-arrow" label="Loans"></ui-bottom-navigation-button>
 *   <ui-bottom-navigation-button glyph="redesign-umbrella" label="Insurance"></ui-bottom-navigation-button>
 * </ui-bottom-navigation>
 */
@Component({
    tag: 'ui-bottom-navigation',
    styles,
})
export class UIBottomNavigation extends UIElement {
    /**
     * @inheritDoc
     */
    render(): void {
        const header = this.createElement({
            tagName: 'header',
            classList: {
                'ui-bottom-navigation': true,
            },
            children: this.childNodes,
        });

        this.appendChild(header);
    }
}
